//アンカーリンク
$(function(){
  $('a[href^="#"]').click(function(){
    // adjust=45：45px上に調整
    const header_height = document.getElementById("shopify-section-header");
    var adjust = header_height.clientHeight - 30;
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を調整：adjust
    var position = target.offset().top - adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});